import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { ConvivaApi } from "src/app/conviva-api";
import { DefaultResponse } from "../models/DefaultResponse";
import { Observable, map } from "rxjs";
import { ParametroPeriodo } from "../models/parametro-periodo/parametro-periodo";

@Injectable({
  providedIn: 'root'
})
export class ParametroPeriodoService {

  private api = ConvivaApi;

  constructor(
    private http: HttpClient,
    private router:Router)
  { }

  public salvarParametroPeriodo(parametros: ParametroPeriodo): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.ParametroPeriodo.SetCadastrarParametroPeriodo}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public excluirParametroPeriodo(codigoParametros: number): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(
      `${this.api.ParametroPeriodo.ExcluirParametroPeriodo}`,
      { codigoParametroPeriodoPlano: codigoParametros }
    );
  }

  public getAllParametroPeriodo():Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(`${this.api.ParametroPeriodo.GetAllParametroPeriodo}`)
                    .pipe(map((response: DefaultResponse) => response));
  }
}
